import React from 'react';
import LoginForm from '../../components/forms/LoginForm/LoginForm';

const Login = () => {
    return (
        <div className="login-page">
            <LoginForm />
        </div>
    );
};

export default Login;
